<template>
  <div class="view-checkout py-5">
    <div class="container py-5">
      <h1 class="mb-4">Finalizar compra</h1>

      <div class="row">
        <div class="col-lg-9">
          <div class="card">
            <card-header :current="step" />

            <div class="card-body">
              <step-1 v-if="step === 1" @success="step = 2" />
              <step-2 v-if="step === 2" />
            </div>
          </div>
        </div>

        <div class="col-lg-3">
          <product-summary :product="product" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardHeader from "@/components/checkout/CardHeader";
import ProductSummary from "@/components/checkout/ProductSummary";
import Step1 from "@/components/checkout/Step1";
import Step2 from "@/components/checkout/Step2";
import { mapState } from "vuex";

export default {
  components: { CardHeader, Step1, Step2, ProductSummary },
  data() {
    return {
      step: 1
    };
  },
  computed: {
    ...mapState("courses", ["product"])
  }
};
</script>

<style lang="scss" scoped>
.view-checkout {
  .card {
    overflow: hidden;
  }
}
</style>
